import { processingGroupIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { toteBarcodeFormatSchema } from "../print-tote-barcodes";

export const printSortingToteBarcodes = {
  name: "printSortingToteBarcodes" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    format: toteBarcodeFormatSchema.optional(),
    copiesPerLabel: z.number().int().min(1).max(4).optional(),
  }),
  output: z.object({ url: z.string() }),
};
